import { Alignment, ValueDisplayValue } from "@mcleod/core";
import { DemoRadioGroupExamples } from "./DemoRadioGroupExamples";
import { LiveExampleComponents } from "../LiveExampleComponents";

export class DemoRadioBoxExamples extends DemoRadioGroupExamples {
    protected override registerExamples() {
        super.registerExamples();
        this.registerPropertyExamples("captionAlignment", {
            examples: [
                { value: Alignment.TOP, description: "The default behavior is to display the caption above the options." },
                { value: Alignment.LEFT, description: "The caption can also be placed to the left of the options." },
            ]
        });
        this.registerPropertyExamples("selectedBackgroundColor", {
            examples: [
                { value: "primary" },
                { value: "success" }
            ],
            onCreate: (exampleComponents: LiveExampleComponents) => this.selectFirstOption(exampleComponents)
        });
        this.registerPropertyExamples("selectedTextColor", {
            examples: [
                { value: "primary.reverse" },
                { value: "warning" }
            ],
            onCreate: (exampleComponents: LiveExampleComponents) => this.selectFirstOption(exampleComponents)
        });
        this.registerPropertyExamples("unselectedBackgroundColor", {
            examples: [
                { value: "primary.reverse" },
                { value: "success" }
            ],
            onCreate: (exampleComponents: LiveExampleComponents) => this.selectFirstOption(exampleComponents)
        });
        this.registerPropertyExamples("unselectedTextColor", {
            examples: [
                //{ value: "default" },
                { value: "error" }
            ],
            onCreate: (exampleComponents: LiveExampleComponents) => this.selectFirstOption(exampleComponents)
        });
        this.registerAddlExamples("Images In Options", "See how a radio box option can include an image", {
            examples: [
                { description: "This example shows how radio box options appear when images are present."}
            ],
            props: {
                items: [
                    new ValueDisplayValue("1", "First Choice").setAddlValue("imageName", "add"),
                    new ValueDisplayValue("2", "Second Choice"),
                    new ValueDisplayValue("3", "Third Choice").setAddlValue("imageName", "acceptTender")
                ]
            }
        });
    }
}
